// extracted by mini-css-extract-plugin
module.exports = {"root":"YouTube-module--root--1WteE"};